import { render, staticRenderFns } from "./worksCatalogue.vue?vue&type=template&id=98193500"
import script from "./worksCatalogue.vue?vue&type=script&lang=js"
export * from "./worksCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98193500')) {
      api.createRecord('98193500', component.options)
    } else {
      api.reload('98193500', component.options)
    }
    module.hot.accept("./worksCatalogue.vue?vue&type=template&id=98193500", function () {
      api.rerender('98193500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/worksCatalogue.vue"
export default component.exports